import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from '../../../services/order.service';
import { Constants } from '../../../model/common.model';
import { PanelModule } from '../../../modules/panel.module';
import { BusinesssSelectorComponent } from '../../business/businesss-selector/businesss-selector.component';
import { UserSelectorComponent } from '../../user/user-selector/user-selector.component';
import { FloatLabelModule } from 'primeng/floatlabel';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { DialogModule } from 'primeng/dialog';
import { Order } from '../../../model/menu-data.model';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { ActionLogListComponent } from '../../action-log-list/action-log-list.component';
import { UserAvatarComponent } from '../../user/user-avatar/user-avatar.component';
import { BusinessAvatarComponent } from '../../business/business-avatar/business-avatar.component';

@Component({
  selector: 'brt-order-list-admin',
  standalone: true,
  imports: [PanelModule, BusinesssSelectorComponent, UserSelectorComponent, FloatLabelModule, TriStateCheckboxModule, 
    DialogModule, TooltipModule, TagModule, DialogModule, ActionLogListComponent, ButtonModule, UserAvatarComponent, 
    BusinessAvatarComponent],
  providers: [],
  templateUrl: './order-list.component.html',
  styleUrl: './order-list.component.scss'
})
export class AdminOrderListComponent {
  constructor(route: ActivatedRoute, private orderService: OrderService) {
    route.queryParams.subscribe(async params => {
      this.criteria = { ...this.criteria, BusinessId: params['bid'], Status: params['status'] };
    });
  }

  orderTypes = Constants.OrderTypes.filter(_ => _ != 'Default');
  orderStatuses = Constants.OrderStatuses.filter(_ => _ != 'Default');
  orderSources = Constants.OrderSources.filter(_ => _ != 'Default');
  selectedOrder?: Order;
  actionLogsOrderId?: string;

  etaOptions = [15, 30, 45, 60, 90];
  defaultEta = 45;
  rejectReasons = ['Busy'];

  @Input() heading = 'Order List';
  loading: boolean;
  orders: any[];
  total: number;
  @Input() criteria: any = {
    TestMode: false,
    Statuses: ['Pending', 'Accepted', 'Preparing', 'Ready', 'Delivering', 'Delivered', 'Canceled', 'Rejected', 'Failed'],
    Sources: ['POS', 'Online']
  };
  async load(event: any = null) {
    this.loading = true;

    this.criteria = {
      ...this.criteria,
      From: event?.first || 0,
      Size: event?.rows || 10
    };
    for (var f in event?.filters) {
      const filter = event.filters[f];
      this.criteria[f] = Array.isArray(filter)
        ? Array.from(filter).map(_ => _.value)
        : filter.value;
    }

    var result = await this.orderService.searchOrder(this.criteria);
    this.orders = result.List;
    this.total = result.Total;
    // this.orders.forEach(_ => {
    //   _._actions = [
    //     // { label: 'View', routerLink: ['/order', _.Id] },
    //     // { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => this.deleteOrder(_) },
    //   ];
    // });
    this.loading = false;
  }

  canAccept(order: any) {
    return order?.Status === 'Pending';
  }

  canReject(order: any) {
    return ['Pending', 'Accepted', 'Preparing', 'Ready'].includes(order?.Status);
  }

  async setStatus(order: any, status: string, etaMinutes?: number | string | null, reason?: string) {
    if (!order?.Id || order._processing) return;
    order._processing = true;
    try {
      const eta = etaMinutes === null || etaMinutes === undefined || etaMinutes === ''
        ? undefined : Number(etaMinutes);
      const updated = await this.orderService.setStatus(order.Id, status, eta, reason || undefined);
      this.orders = this.orders.map(o => o.Id === order.Id ? { ...o, ...updated } : o);
    } finally {
      order._processing = false;
    }
  }

}
